'use client'
import Text from "@/components/typographie/Text/Text";
import React, {useContext} from "react";
import Link from "next/link";
import {ContentContext, ContentTypeContext, YearContext} from "@/components/ContentElements/News/Provider/NewsFilterProvider";

interface Props {
    contentTags: string[] | undefined
    align?: string
    isLink?: boolean
}

export default function NewsTags({contentTags, align, isLink = false}:Props) {
    const { setContent } = useContext(ContentContext);
    const { setContentType } = useContext(ContentTypeContext);
    const { setYear } = useContext(YearContext);
    const setFilter = (tag:string) => {
        setContent(tag)
        setContentType('')
        setYear('')
    }

    return (
        <div className={" flex items-" + align + " justify-" + align + " gap-x-s gap-y-s sm:gap-x-l sm:gap-y-s flex-wrap"}>
            {contentTags?.map(tag => {
                return (
                    <div key={tag}>
                        {isLink ? (
                            <Link href="/newsroom/news" onClick={() => setFilter(tag)} className="bg-black px-xs py-[2px] rounded-[2px] text-white text-above font-bonprix">
                                {tag}
                            </Link>
                        ) : (
                            <Text type="above" className="bg-black px-xs py-[2px] rounded-[2px] text-white">{tag}</Text>
                        )}
                    </div>
                )
            })}
        </div>
    )
}